
import React from "react";


import {Well,Label,Panel,Glyphicon,Button } from "react-bootstrap";


function getVar(varName,vars){
  let v=vars[varName]

  if(v==undefined)
    return varName
  return v
}




function actionContext(d,vars,macros,outputs,schedule,events){
//  console.log(d)
  if(d.cmd=="outputCtrl"){
    //How can i get the context of the output from here, does additional data need to be passed to the obkect?
    //console.log(d.outputID)

    for (var i=0;i<outputs.length;i++){
        if (outputs[i].id==d.outputID){
          return outputs[i].name+" ("+d.type+")"
        }
    }

  //  console.log("Action Context"+d)
//    console.log("Action Context"+outputs)
    return "Output reference error"
  }
  if(d.cmd=="say"){
    //How can i get the context of the output from here, does additional data need to be passed to the obkect?
    return "Say: "+d.text
  }
  if(d.cmd=="log"){
    //How can i get the context of the output from here, does additional data need to be passed to the obkect?
    return "Log: "+d.name+" => "+d.string
  }

  if(d.cmd=="system"){
    //How can i get the context of the output from here, does additional data need to be passed to the obkect?
    return "System => "+d.string
  }
  if(d.cmd=="script"){
    //How can i get the context of the output from here, does additional data need to be passed to the obkect?
    return "Run Script: "+d.name
  }
  if(d.cmd=="varCtrl"){
    if(d.type=="increment"){
      return "Variable ("+d.name+") increment"
    }
    return "Variable ("+d.name+") "+d.type+" to "+d.value
  }
  if(d.cmd=="buzzer"){
    if(d.count==1){
      return "Sound Buzzer once for "+d.ontime+"ms"
    }
    else{
      return "Sound Buzzer "+d.count+" times, on for "+d.ontime+"ms off for "+d.offtime+"ms"
    }
  }

  if(d.cmd=="alertlist"){

    return "Alert Contacts: "+d.message

  }

  if(d.cmd=="delay"){

    return "Delay for "+d.data+"ms"

  }


  if(d.cmd=="schedule"){
    if( "name" in d){
      return " schedle:"+d.name
    }
    //  console.log(macros)
      try{
        return d.type+" schedule:"+schedule[d.data].name
      }
      catch(err){
      //  console.log(macros)
    //    console.log(d)
        return "schedule:"+d.data+ " Not Found!"
      }

  }


  if(d.cmd=="event"){
    if( "name" in d){
      return " Event:"+d.name
    }
    //  console.log(macros)
      try{
        return d.type+" Event:"+events[d.data].name
      }
      catch(err){
      //  console.log(macros)
    //    console.log(d)
        return "Event:"+d.data+ " Not Found!"
      }

  }

  if(d.cmd=="macro"){
    if( "name" in d){
      return " macro:"+d.name
    }
    //  console.log(macros)
      try{
        return d.type+" macro:"+macros[d.data].name
      }
      catch(err){
      //  console.log(macros)
    //    console.log(d)
        return "Macro:"+macros[d.data]+ " Not Found!"
      }

  }

  if(d.cmd=="buildString"){
    let tmpstr=[]
    d.vars.forEach(function(e){tmpstr.push(getVar(e,vars))})
    //console.log(tmpstr)
    tmpstr=tmpstr.join(d.join)
    //else{
    //tmpstr=tmpstr.vars.join(" ")
    //}
    return "BuildString: "+tmpstr+" ==> "+d.saveVar
  }
  if(d.cmd=="modbus"){
    let tmpstr=[]


    //}
    return "Modbus: Addr "+d.address
  }
  if(d.cmd=="dali"){
    let daliaddress=""

    if( (d.address&0x80)==0x80){
      //Top bit is set
      if(d.address==255)
            daliaddress=" Broadcast command "
      if(d.address==254)
          daliaddress=" Broadcast level "
      if( (d.address)>>5==0x04){
        //Its a group
        daliaddress="Group "+(d.address>>1 & 0x0F)+" "
        if(d.address&1)
            daliaddress+=" command "+d.command
        else
            daliaddress+=" level "+d.command
      }

      if(daliaddress==""){
        daliaddress ="Special command "
      }
//11111101    253


    }else{
      daliaddress="Short Address "+(d.address>>1 & 0x3F)+" "
      if(d.address&1)
          daliaddress+=" command "+d.command
      else
          daliaddress+=" level "+d.command
    }
    //Is it a group

    //is it an address




    //}
    return "DALI: BUS "+d.bus+" "+daliaddress
  }
  return d.cmd

}





export const ActionsDisplay = (props)=>{
  let d=props.data
  let vars=props.vars
  let macros=props.macros
  let outputs=props.outputs
  let schedule=props.schedule
  let events=props.events
  return (<span className="capitalize">{actionContext(d,vars,macros,outputs,schedule,events)}</span>)
}



// WEBPACK FOOTER //
// ./src/programmerComponents/ActionsDisplay.js